module.exports = __webpack_public_path__ + "static/media/04.dffbb0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/camera/04.png
// module id = 633
// module chunks = 0